import * as forge from 'node-forge'
import conf from './conf'
import { restLandingClient } from './myNet'
import localforage from './myStore'

import { ClientJS } from 'clientjs'

import { customFetch } from 'services/jwt'

// Type definitions
interface PublicKeyResponse {
  data: {
    version: string
    publicKey: string
  }
}

interface EncryptedResponseData {
  errors?: any
  code: number
  [key: string]: any
}

type SuccessCallback = (data: EncryptedResponseData) => void
type FailCallback = (error: any) => void

function strToBytes(str: string): Uint8Array {
  const bytes = new Uint8Array(str.length)
  for (let i = 0; i < str.length; i += 1) {
    const char = str.charCodeAt(i)
    bytes[i] = char
  }
  return bytes
}

export function encodeBase64(str: string): string {
  const utf8Str = forge.util.encodeUtf8(str)
  const base64Str = forge.util.encode64(utf8Str)
  return base64Str
}

export function sendEncrypted(
  apiName: string,
  params: Record<string, any>,
  successFunc: SuccessCallback,
  failFunc: FailCallback,
): void {
  console.log(params)
  const publicKeyURL = '/provisioning/public_key/json'

  restLandingClient.get(publicKeyURL).then((res) => {
    const { version, publicKey } = res.data.data as PublicKeyResponse['data']

    const api = `${conf.SERVER.restLandingURL}${apiName}${version}`

    const body0 = JSON.stringify(params)

    const body = forge.util.encodeUtf8(body0)

    console.log(' --- ', body, publicKey)

    let bytes: Uint8Array | null = null

    // production일 때만 encrypte 사용.
    if (import.meta.env.MODE !== 'log') {
      const publicKeyObj = forge.pki.publicKeyFromPem(publicKey)

      const encrypted = publicKeyObj.encrypt(body, 'RSA-OAEP', {
        md: forge.md.sha256.create(),
        mgf1: {
          md: forge.md.sha256.create(),
        },
      })

      bytes = strToBytes(encrypted)
    } else {
      bytes = strToBytes(body)
    }

    const blob = new Blob([bytes as BlobPart], { type: 'application/octet-stream' })

    console.log(blob)

    // const token = await localforage.getItem('app.user.token')
    // return the headers to the context so httpLink can read them

    const ret = customFetch(
      api,
      {
        method: 'POST',
        headers: {
          // authorization: `JWT ${token}`,
          // 'Content-Type': 'text/plain',
          // 'Content-Type': 'application/json',
          'content-type': 'application/x-www-form-urlencoded',
          // 'content-type': 'application/octet-stream',
        },
        body: blob,
      },
      null,
    )

    ret
      .then((sres) => {
        console.log(' subscribe - ', sres)

        sres.json().then((data: EncryptedResponseData) => {
          console.log(' - ret : ', data)

          if (data.errors != null || data.code !== 200) {
            failFunc(data)
          } else if (successFunc != null) {
            successFunc(data)
          }
        })
      })
      .catch((error) => {
        failFunc(error)
      })
  })
}

export async function getDeviceUUID(email: string): Promise<string> {
  // ✅ 수정: 계정별 UUID 분리를 위해 email 해시를 키에 포함
  const emailMd = forge.md.md5.create()
  emailMd.update(email || '')
  const emailHash = emailMd.digest().toHex().substring(0, 8) // 8자리만 사용

  const storageKey = `app.device.uuid.${emailHash}`
  let uuid = await localforage.getItem<string>(storageKey)

  if (uuid == null) {
    const client = new ClientJS()
    const fingerprint = client.getFingerprint()
    const curTime = Date.now()

    const md = forge.md.md5.create()
    // ✅ 보안: email 평문 대신 해시 사용
    md.update(`${emailHash}_${fingerprint}_${curTime}`)
    const hex = md.digest().toHex()
    uuid = `RW${hex}`
    await localforage.setItem(storageKey, uuid)
    console.log(`[UUID] Created new UUID for account: ${emailHash}`)
  } else {
    console.log(`[UUID] Using existing UUID for account: ${emailHash}`)
  }

  return Promise.resolve(uuid)
}

// Note: This function is commented out because it references undefined dependencies
// (Ngql, AntMessage, i18n, notification, clientForLanding)
// Uncomment and add proper types when these dependencies are available
/*
export function updateAccountInfo(
  id: string | null,
  sendData: Record<string, any>,
  onUpdated?: () => void,
  hideResultMsg?: boolean,
): void {
  const mutation = Ngql.Mutation('updateUserInfo', {
    updateUser: Ngql.Node(
      {
        ok: true,
        errors: true,
      },
      null,
      false,
      {
        userData: Ngql.Var('userData', 'updateUserInput'),
        userGid: Ngql.Var('userGid', 'String'),
      },
    ),
  })

  const variables: {
    userData: Record<string, any>
    userGid?: string
  } = {
    userData: {
      // displayName: (displayName == null || displayName.length === 0) ? ' ' : displayName,
      // displayName,
      // avatarUrl,
      ...sendData,
    },
    // userGid: 'VXNlck5vZGU6MTk=',
  }

  if (id != null) {
    variables.userGid = id
  }

  Ngql.GQLObj(mutation, { vars: variables })
    .mutate({}, clientForLanding)
    .then((res: any) => {
      console.log(res)
      if (hideResultMsg !== true) {
        AntMessage.info(i18n.t('profile.result.modified'))
      }
      if (onUpdated != null) {
        onUpdated()
      }
      return true
    })
    .catch((error: any) => {
      console.log(error)
      notification.warning({
        message: error.code,
        description: error.message,
      })
    })
}
*/

const pUtils = {
  sendEncrypted,
  getDeviceUUID,
  encodeBase64,
}

export default pUtils
